<div *ngIf="usePopover">
	<mat-form-field
		#popoverTrigger="mtxPopoverTrigger"
		(click)="$event.stopPropagation()"
		[mtxPopoverTriggerFor]="carrierPopover"
		class="{{ customFormFieldClass }}"
		floatLabel="never"
		fxFlex
		mtxPopoverTriggerOn="click"
	>
		<mat-label [ngClass]="{ 'primary-text': placeholder !== 'Carrier' }">{{
			placeholder
		}}</mat-label>
		<input matInput readonly="true" />
		<mat-icon *ngIf="renderDownArrowIcon()" class="vertical-align-middle" matSuffix
			>keyboard_arrow_down
		</mat-icon>
		<mat-icon
			(click)="$event.stopPropagation(); removeSelectedCarrier()"
			*ngIf="renderCloseArrowIcon()"
			class="vertical-align-middle danger-text cursor-pointer"
			matSuffix
		>
			close
		</mat-icon>
	</mat-form-field>

	<mtx-popover #carrierPopover="mtxPopover" [closeOnPanelClick]="false">
		<mat-card class="p-0 primary-border">
			<mat-card-content class="carriers-dropdown font-size-14 p-b-2">
				<div class="padding-0-5" fxLayout="row">
					<mat-form-field fxFlex>
						<input
							(input)="inputChanged($event.target.value)"
							[(ngModel)]="searchText"
							autocomplete="off"
							matInput
							placeholder="Type to filter"
						/>
					</mat-form-field>
				</div>
				<div *ngIf="isLoadingCarriersList" class="padding-0-5" fxLayout="row">
					<div fxFlex fxLayoutAlign="center center">
						<mat-spinner [diameter]="11"></mat-spinner>
					</div>
				</div>
				<div
					(click)="setSelectedCarrier(carrier)"
					*ngFor="let carrier of carriersList"
					class="padding-0-5 carrier-row cursor-pointer"
					fxLayout="row"
				>
					<div class="primary-text" fxFlex fxLayoutAlign="start center">
						{{ carrier.businessName }}
					</div>
				</div>

				<div
					*ngIf="!isLoadingCarriersList && searchText.length > 0 && carriersList.length === 0"
					class="padding-0-5 carrier-row"
				>
					<div class="link" fxFlex fxLayoutAlign="center center">No Carriers Found</div>
				</div>
			</mat-card-content>
		</mat-card>
	</mtx-popover>
</div>

<div *ngIf="useAutoComplete">
	<mat-form-field class="full-width" floatLabel="never">
		<input
			#carrierInput
			(input)="inputChanged($event.target.value)"
			[(ngModel)]="searchText"
			[matAutocomplete]="auto"
			[disabled]="disabled"
			matInput
			placeholder="Carrier"
		/>

		<mat-autocomplete
			#auto="matAutocomplete"
			(optionSelected)="selected($event)"
			[displayWith]="displayFn"
		>
			<mat-option *ngIf="isLoadingCarriersList" fxLayoutAlign="center center">
				<mat-spinner [diameter]="30"></mat-spinner>
			</mat-option>

			<ng-container *ngIf="!isLoadingCarriersList">
				<mat-option *ngFor="let carrier of carriersList" [value]="carrier">
					{{ carrier.businessName }}
				</mat-option>
			</ng-container>
		</mat-autocomplete>
	</mat-form-field>
</div>
